/**
 * Gymshark / Monster Guardians Wishlist & Account Navigation Controller
 */
(function() {
  'use strict';

  var Wishlist = {
    storageKey: 'theme_wishlist_handles',

    init: function() {
      this.bindEvents();
      this.checkPendingWishlist();
      this.updateAllHeartButtons();
      this.initWishlistPage();
      this.cleanUpAllAccountMenus();
      this.observeAccountMenu();
    },

    cleanUpAllAccountMenus: function() {
      var self = this;
      var popovers = document.querySelectorAll('.account-popover');
      popovers.forEach(function(popover) {
        self.cleanUpAccountMenu(popover);
      });
    },

    observeAccountMenu: function() {
      var wrapper = document.querySelector('.site-account-menu-wrapper');
      if (!wrapper) return;

      var self = this;
      var observer = new MutationObserver(function(mutations) {
        var shouldClean = false;
        mutations.forEach(function(m) {
          if (!m.addedNodes) return;
          m.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.matches('nav.stack-inline, .account-popover__actions') || node.querySelector('nav.stack-inline, .account-popover__actions')) {
                shouldClean = true;
              }
            }
          });
        });
        if (shouldClean) {
          self.cleanUpAccountMenu();
        }
      });

      observer.observe(wrapper, { childList: true, subtree: true });
    },

    cleanUpAccountMenu: function(popover) {
      if (this._isCleaningUp) return;
      this._isCleaningUp = true;

      try {
        if (!popover) popover = document.getElementById('AccountPopover');
        if (!popover) return;

        var wrapper = popover.closest('.site-account-menu-wrapper') || document.querySelector('.site-account-menu-wrapper');

        var isLoggedIn = false;
        if (window.theme && typeof window.theme.customerLoggedIn !== 'undefined') {
          isLoggedIn = window.theme.customerLoggedIn;
        }
        if (!isLoggedIn) {
          isLoggedIn = popover.querySelector('.account-popover__email') !== null ||
                       (wrapper && wrapper.classList.contains('is-logged-in'));
        }

        if (isLoggedIn) {
          if (wrapper && !wrapper.classList.contains('is-logged-in')) {
            wrapper.classList.add('is-logged-in');
          }

          // Hide any injected nav.stack-inline or guest login/register actions
          var injected = popover.querySelectorAll('nav.stack-inline, .account-popover__actions');
          injected.forEach(function(el) {
            if (el.style.display !== 'none') {
              el.style.display = 'none';
            }
          });

          var body = popover.querySelector('.account-popover__body');
          if (body) {
            body.style.display = 'block';
            body.classList.remove('account-popover__body--guest');
            body.classList.add('account-popover__body--logged-in');
          }

          var menu = popover.querySelector('.account-popover__menu');
          if (!menu) {
            menu = document.createElement('div');
            menu.className = 'account-popover__menu';
            if (body) body.appendChild(menu);
          }

          // Ensure My Orders button exists
          if (!menu.querySelector('a[href*="/account"]:not([href*="logout"]):not([href*="profile"])')) {
            var ordersBtn = document.createElement('a');
            ordersBtn.href = '/account';
            ordersBtn.className = 'account-popover__btn';
            ordersBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> My Orders';
            menu.insertBefore(ordersBtn, menu.firstChild);
          }

          // Ensure Profile button exists
          if (!menu.querySelector('a[href*="profile"]')) {
            var profileBtn = document.createElement('a');
            profileBtn.href = '/account/profile';
            profileBtn.className = 'account-popover__btn';
            profileBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> Profile';
            var wishlistBtn = menu.querySelector('a[href*="wishlist"]');
            if (wishlistBtn) {
              menu.insertBefore(profileBtn, wishlistBtn);
            } else {
              menu.appendChild(profileBtn);
            }
          }

          // Ensure Log Out button exists
          var logoutBtn = popover.querySelector('.account-popover__btn--logout');
          if (!logoutBtn) {
            logoutBtn = document.createElement('a');
            logoutBtn.href = '/account/logout';
            logoutBtn.className = 'account-popover__btn account-popover__btn--logout';
            logoutBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg> Log Out';
            menu.appendChild(logoutBtn);
          } else if (logoutBtn.style.display !== 'flex') {
            logoutBtn.style.display = 'flex';
          }
        }
      } finally {
        this._isCleaningUp = false;
      }
    },

    getWishlist: function() {
      try {
        var saved = localStorage.getItem(this.storageKey);
        var parsed = saved ? JSON.parse(saved) : [];
        if (!Array.isArray(parsed)) return [];
        return parsed.filter(function(item) {
          return typeof item === 'string' && item.trim().length > 0;
        });
      } catch (e) {
        return [];
      }
    },

    setWishlist: function(items) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(items));
      } catch (e) {}
    },

    hasItem: function(handle) {
      var items = this.getWishlist();
      return items.indexOf(handle) !== -1;
    },

    toggleItem: function(handle) {
      var items = this.getWishlist();
      var index = items.indexOf(handle);
      if (index === -1) {
        items.push(handle);
      } else {
        items.splice(index, 1);
      }
      this.setWishlist(items);
      this.updateAllHeartButtons();
      return index === -1; // true if added, false if removed
    },

    removeItem: function(handle) {
      var items = this.getWishlist();
      var index = items.indexOf(handle);
      if (index !== -1) {
        items.splice(index, 1);
        this.setWishlist(items);
        this.updateAllHeartButtons();
      }
    },

    checkPendingWishlist: function() {
      var pendingHandle = sessionStorage.getItem('pending_wishlist_handle');
      var returnUrl = sessionStorage.getItem('pending_wishlist_return_url');
      var wishlistLoginInitiated = sessionStorage.getItem('wishlist_login_initiated') === 'true';

      var isLoggedIn = false;
      if (window.theme && typeof window.theme.customerLoggedIn !== 'undefined') {
        isLoggedIn = window.theme.customerLoggedIn;
      } else {
        var anyBtn = document.querySelector('[data-wishlist-btn]');
        isLoggedIn = anyBtn && anyBtn.getAttribute('data-customer-logged-in') === 'true';
      }

      var currentPath = window.location.pathname.toLowerCase();
      var isAccountPage = currentPath.indexOf('/account') === 0 || currentPath.indexOf('/challenge') === 0;
      var ref = document.referrer.toLowerCase();

      // 1. ONLY redirect back to original page IF login was initiated from Wishlist Modal!
      if (wishlistLoginInitiated && returnUrl && isAccountPage) {
        sessionStorage.removeItem('wishlist_login_initiated');
        window.location.replace(returnUrl);
        return;
      }

      // 2. If user clicked "Shop Now" from Shopify Customer Accounts Portal and landed on homepage, redirect to /collections/all
      if ((ref.indexOf('/account/orders') !== -1 || ref.indexOf('/account') !== -1) && (currentPath === '/' || currentPath === '')) {
        window.location.replace('/collections/all');
        return;
      }

      // If user is on account page and login was NOT from wishlist modal, clear any old flags and let them stay on Account Dashboard!
      if (isAccountPage && !wishlistLoginInitiated) {
        sessionStorage.removeItem('pending_wishlist_handle');
        sessionStorage.removeItem('pending_wishlist_return_url');
        return;
      }

      // 3. If customer is now logged in (or returned to original page) and has a pending item to wishlist
      if (isLoggedIn && pendingHandle) {
        if (!this.hasItem(pendingHandle)) {
          this.toggleItem(pendingHandle);
        }
        sessionStorage.removeItem('pending_wishlist_handle');
        sessionStorage.removeItem('pending_wishlist_return_url');
        sessionStorage.removeItem('wishlist_login_initiated');
      }
    },

    updateHeaderCount: function() {
      var items = this.getWishlist();
      var count = items.length;
      var bubbles = document.querySelectorAll('[data-wishlist-count]');
      bubbles.forEach(function(bubble) {
        if (count > 0) {
          bubble.innerText = count;
          bubble.classList.add('wishlist-link__bubble--visible');
        } else {
          bubble.innerText = '0';
          bubble.classList.remove('wishlist-link__bubble--visible');
        }
      });
    },

    updateAllHeartButtons: function() {
      var items = this.getWishlist();
      var buttons = document.querySelectorAll('[data-wishlist-btn]');
      buttons.forEach(function(btn) {
        var handle = btn.getAttribute('data-product-handle');
        if (handle && items.indexOf(handle) !== -1) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
      this.updateHeaderCount();
    },

    bindEvents: function() {
      var self = this;

      // Delegate click for wishlist heart buttons
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-wishlist-btn]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();

          var isLoggedIn = false;
          if (window.theme && typeof window.theme.customerLoggedIn !== 'undefined') {
            isLoggedIn = window.theme.customerLoggedIn;
          } else {
            isLoggedIn = btn.getAttribute('data-customer-logged-in') === 'true';
          }
          
          var handle = btn.getAttribute('data-product-handle');

          if (!isLoggedIn) {
            self.openModal(handle);
          } else if (handle) {
            self.toggleItem(handle);
          }
        }

        // Account Popover Toggle Handler
        var accountTrigger = e.target.closest('.js-account-popover-trigger');
        if (accountTrigger) {
          e.preventDefault();
          e.stopPropagation();
          var wrapper = accountTrigger.closest('.site-account-menu-wrapper');
          var popover = wrapper ? wrapper.querySelector('.account-popover') : document.getElementById('AccountPopover');
          if (popover) {
            popover.classList.toggle('is-active');
            self.cleanUpAccountMenu(popover);
          }
          return;
        }

        var accountClose = e.target.closest('.js-account-popover-close');
        if (accountClose) {
          e.preventDefault();
          var wrapper = accountClose.closest('.site-account-menu-wrapper');
          var popover = wrapper ? wrapper.querySelector('.account-popover') : document.getElementById('AccountPopover');
          if (popover) {
            popover.classList.remove('is-active');
          }
          return;
        }

        // Close Account Popover when clicking outside
        var insidePopover = e.target.closest('.site-account-menu-wrapper');
        if (!insidePopover) {
          var activePopovers = document.querySelectorAll('.account-popover.is-active');
          activePopovers.forEach(function(popover) {
            popover.classList.remove('is-active');
          });
        }

        // Detect click on Wishlist Modal login/register action buttons
        var modalActionBtn = e.target.closest('.wishlist-modal__btn');
        if (modalActionBtn) {
          sessionStorage.setItem('wishlist_login_initiated', 'true');
        }

        // Detect click on header/navigation account links (normal login flow)
        var accountLink = e.target.closest('a[href*="/account"]:not(.wishlist-modal__btn), .site-nav__link[href*="/account"]');
        if (accountLink) {
          sessionStorage.removeItem('wishlist_login_initiated');
          sessionStorage.removeItem('pending_wishlist_handle');
          sessionStorage.removeItem('pending_wishlist_return_url');
        }

        // Intercept any "Shop Now" button clicks on account page / portal and redirect to /collections/all
        var shopNowBtn = e.target.closest('a, button, [role="button"]');
        if (shopNowBtn) {
          var text = (shopNowBtn.innerText || shopNowBtn.textContent || '').trim().toLowerCase();
          if (text === 'shop now' || text === 'ready to shop?') {
            var currentPath = window.location.pathname.toLowerCase();
            if (currentPath.indexOf('/account') === 0 || document.referrer.indexOf('/account') !== -1 || shopNowBtn.closest('[class*="account"]')) {
              e.preventDefault();
              e.stopPropagation();
              window.location.href = '/collections/all';
            }
          }
        }
      }, true);

      // Delegate modal close clicks
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-wishlist-modal-close]')) {
          e.preventDefault();
          self.closeModal();
        }
      });

      // Escape key to close modal
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          self.closeModal();
        }
      });
    },

    openModal: function(handle) {
      var modal = document.getElementById('WishlistModal');
      if (!modal) return;

      var currentUrl = window.location.href;

      if (handle) {
        sessionStorage.setItem('pending_wishlist_handle', handle);
      }
      sessionStorage.setItem('pending_wishlist_return_url', currentUrl);

      // Dynamically update Login & Create Account return_to query parameters
      var returnParam = encodeURIComponent(currentUrl);
      var registerBtn = modal.querySelector('.wishlist-modal__btn--primary');
      var loginBtn = modal.querySelector('.wishlist-modal__btn--secondary');

      if (registerBtn) {
        registerBtn.setAttribute('href', '/account/register?return_to=' + returnParam);
      }
      if (loginBtn) {
        loginBtn.setAttribute('href', '/account/login?return_to=' + returnParam);
      }

      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },

    closeModal: function() {
      var modal = document.getElementById('WishlistModal');
      if (modal) {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    },

    initWishlistPage: function() {
      var container = document.getElementById('MainWishlistSection');
      if (!container) return;

      var self = this;
      var grid = document.getElementById('WishlistGrid');
      var emptyState = document.getElementById('WishlistEmptyState');
      var countEl = document.getElementById('WishlistCount');
      var items = this.getWishlist();

      if (!grid) return;

      if (items.length === 0) {
        if (grid) grid.style.display = 'none';
        if (emptyState) emptyState.style.display = 'block';
        if (countEl) countEl.innerText = '0 items';
        return;
      }

      if (emptyState) emptyState.style.display = 'none';
      if (grid) grid.style.display = 'grid';
      if (countEl) countEl.innerText = items.length + (items.length === 1 ? ' item' : ' items');

      grid.innerHTML = '';

      // Fetch each product via AJAX endpoint
      items.forEach(function(handle) {
        fetch('/products/' + handle + '.js')
          .then(function(res) {
            if (!res.ok) throw new Error('Not found');
            return res.json();
          })
          .then(function(product) {
            var card = self.renderWishlistCard(product);
            grid.appendChild(card);
          })
          .catch(function(err) {
            console.warn('Could not load wishlist item:', handle);
          });
      });
    },

    renderWishlistCard: function(product) {
      var self = this;
      var div = document.createElement('div');
      div.className = 'wishlist-card';
      div.setAttribute('data-handle', product.handle);

      var formattedPrice = (product.price / 100).toFixed(2);
      var currencySymbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active + ' ' : '$';

      div.innerHTML = `
        <div class="wishlist-card__image-wrap">
          <button type="button" class="wishlist-card__remove-btn" aria-label="Remove item" data-remove-handle="${product.handle}">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <a href="${product.url}">
            <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
          </a>
        </div>
        <div class="wishlist-card__details">
          <a href="${product.url}" class="wishlist-card__title">${product.title}</a>
          <div class="wishlist-card__price">${currencySymbol}${formattedPrice}</div>
          <button type="button" class="wishlist-card__add-btn" data-add-to-cart="${product.variants[0].id}">Add to Cart</button>
        </div>
      `;

      // Bind remove button
      div.querySelector('[data-remove-handle]').addEventListener('click', function(e) {
        e.preventDefault();
        var handle = this.getAttribute('data-remove-handle');
        self.removeItem(handle);
        div.remove();
        self.initWishlistPage();
      });

      // Bind add to cart button
      div.querySelector('[data-add-to-cart]').addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = this.getAttribute('data-add-to-cart');
        var btn = this;
        btn.innerText = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.innerText = 'Added!';
          setTimeout(function() { btn.innerText = 'Add to Cart'; }, 1500);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        })
        .catch(function() {
          btn.innerText = 'Add to Cart';
        });
      });

      return div;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { Wishlist.init(); });
  } else {
    Wishlist.init();
  }

  window.ThemeWishlist = Wishlist;
})();
